import { css } from 'styled-components';
var styles = css(["&.nva-map{height:100%;width:100%;}.nva-map__iw-loading{margin:10px 80px;}", ""], function (_ref) {
  var hasOldIcons = _ref.hasOldIcons;
  return hasOldIcons && css(["svg[fill='#0000ff'],svg[fill='#ff0000']{fill:hsl(127.8 58.85% 40.98% / 50%);width:50px;height:50px;text{font-size:70px;font-weight:bold;}circle{opacity:1;r:50%;&:not(:first-child){display:none;}}}"]);
});
export default styles;